import { Injectable } from '@angular/core';
import { RealEstateObjectId } from '@immosky/types';

export type DetailPageUrlOrigin = 'list-card' | 'map-card';

@Injectable({
  providedIn: 'root',
})
export abstract class DetailPageService {
  abstract getDetailPageUrlForId(id: RealEstateObjectId): string;

  abstract goTo(pageUrl: string, origin: DetailPageUrlOrigin): void;
}
